const SUCCESS_MESSAGES = {
  UPDATE_PERSONAL_INFORMATION: 'Your personal information has been successfully updated!',
  UPDATE_USER_PROFILE_DATA: 'Your user preferences have been successfully updated!',
  UPDATE_ADDRESS: 'Your address has been successfully updated!'
};

export default SUCCESS_MESSAGES;
